import { Fragment } from 'react';

import TimesEvents from '@usas/ui-web/components/searches/searchTime/components/TimesEvents';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import DatePicker from '@usas/ui-web/components/datepickers/DatePicker';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import Input from '@usas/ui-web/components/inputs/Input';
import Headings from '@usas/ui-web/components/headings/Headings';
import TimeInput from '@usas/ui-web/components/inputs/TimeInput';
import SessionDropdown from '@usas/ui-web/components/dropdowns/sessionDropdown/SessionDropdown';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const AddEditForm = ({ state, formState, errorState, timeState, eventState, onFormValueChanged, onValueTextPairChanged,
  onSubmit, resetForm, onShowPopup }) => {
  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Time Info</Headings.H3>
        </div>
      </div>
      <form onSubmit={onSubmit} noValidate>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <TimesEvents
              label="Event*"
              eventName={"eventId"}
              eventValue={formState.eventName}
              eventId={errorState.eventId}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'eventId', newValueLabel, 'eventName', e); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label="Event Gender*"
              name="eventGenderId"
              options={state.competitionGenderOptions}
              isLoading={false}
              areValuesIntegers={true}
              value={formState.eventGenderId}
              error={errorState.eventGenderId}
              message={errorState.eventGenderId}
              onChange={(id, name) => { onValueTextPairChanged(id, 'eventGenderId', name, 'eventGenderName'); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <SessionDropdown
              label="Session"
              name="sessionId"
              value={formState.sessionId}
              error={errorState.sessionId}
              message={errorState.sessionId}
              onChange={(id, name) => { onValueTextPairChanged(id, 'sessionId', name, 'sessionName'); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <TimeInput
              label="Entry Time"
              name="entryTime"
              value={formState.entryTime}
              error={errorState.entryTime}
              message={errorState.entryTime}
              onChange={(displayValue, value) => { onValueTextPairChanged(displayValue, 'entryTime', value, 'entryTimeValue'); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <TimeInput
              label="Swim Time*"
              name="swimTime"
              value={formState.swimTime}
              error={errorState.swimTime}
              message={errorState.swimTime}
              onChange={(displayValue, value) => { onValueTextPairChanged(displayValue, 'swimTime', value, 'swimTimeValue'); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <DatePicker
              label="Swim Date*"
              name="swimDate"
              value={formState.swimDate}
              error={errorState.swimDate}
              message={errorState.swimDate}
              onChange={(value) => { onFormValueChanged('swimDate', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Place"
              name="place"
              type="number"
              min="0"
              value={formState.place}
              error={errorState.place}
              message={errorState.place}
              onChange={(value) => { onFormValueChanged('place', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <YesNoSwitch
              label="Relay Lead-Off?"
              name="isRelayLeadOff"
              checked={formState.isRelayLeadOff === true}
              error={errorState.isRelayLeadOff}
              message={errorState.isRelayLeadOff}
              onChange={(value) => { onFormValueChanged('isRelayLeadOff', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Event Number"
              name="eventNumber"
              type="number"
              min="1"
              max="999"
              error={errorState.eventNumber}
              message={errorState.eventNumber}
              value={formState.eventNumber}
              onChange={(value) => { onFormValueChanged('eventNumber', (value)) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Event Age Minimum"
              name="eventAgeMin"
              type="number"
              min="1"
              max="99"
              error={errorState.eventAgeMin}
              message={errorState.eventAgeMin}
              value={formState.eventAgeMin}
              onChange={(value) => { onFormValueChanged('eventAgeMin', (value)) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Event Age Maximum"
              name="eventAgeMax"
              type="number"
              min="1"
              max="99"
              error={errorState.eventAgeMax}
              message={errorState.eventAgeMax}
              value={formState.eventAgeMax}
              onChange={(value) => { onFormValueChanged('eventAgeMax', (value)) }} />
          </div>
        </div>
        {errorState.errorOnSubmitAction &&
          <div className="row">
            <div className="col-xs-12">
              <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
            </div>
          </div>
        }
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={resetForm}>Cancel</SecondaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onShowPopup}>Delete</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={timeState.isObjLoading || eventState.isArrayLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={timeState.isSaving} />
    </Fragment>
  );
};

export default AddEditForm;